import { render, staticRenderFns } from "./table-overHidden.vue?vue&type=template&id=60089998&scoped=true&"
import script from "./table-overHidden.vue?vue&type=script&lang=js&"
export * from "./table-overHidden.vue?vue&type=script&lang=js&"
import style0 from "./table-overHidden.vue?vue&type=style&index=0&id=60089998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60089998",
  null
  
)

export default component.exports